import { TRANSLATIONS_EN } from './translations/english';

const resources = {
    en: {
        translation: TRANSLATIONS_EN
    }
};

export default resources;
